import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Register, GetUrlResponse } from "../types/file-types";

@Injectable({
  providedIn: "root",
})
export class FileService {
  private readonly BASE_URL = `${environment.webapiURL}/files`;

  constructor(private http: HttpClient) {}

  public uploadOrderFile(idPedido: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    const uploadUrl = `${environment.webapiURL}/orders/upload`;

    return this.http.post(uploadUrl, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  /**
   * Faz upload da planilha e cria múltiplos pedidos automaticamente
   * @param file Arquivo da planilha (xlsx, xlsm, xls)
   * @param customerId ID do cliente (obrigatório para usuários Tereos)
   */
  public uploadOrdersFromFile(file: File, customerId?: number | string): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    
    if (customerId) {
      formData.append("gtm_customer_id", customerId.toString());
    }

    const uploadUrl = `${environment.webapiURL}/orders/upload-orders`;

    return this.http.post(uploadUrl, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  public getRecords(path: string) {
    return this.http.get<Array<Register>>(
      `${this.BASE_URL}?prefix=${path ? path + "/" : ""}`
    );
  }

  public createFolder(folderName: string, path: string) {
    const data = new FormData();
    data.append("title", folderName);
    data.append("directory", path);
    return this.http.post(this.BASE_URL, data);
  }

  public uploadFile(preSignedUrl: string, file: File): Observable<any> {
    return this.http.put(preSignedUrl, file, {
      headers: this.getUploadHeaders(file.type),
    });
  }

  public getPresignedUrl(file: File, path: string): Observable<GetUrlResponse> {
    const preSignedApiUrl = `${this.BASE_URL}/url`;
    const data = {
      title: file.name,
      contentType: file.type,
      directory: path,
    };

    return this.http.post<GetUrlResponse>(preSignedApiUrl, data).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public getFileDownloadUrl(key: string) {
    const url = `${this.BASE_URL}/download?key=${key}`;
    return this.http.get<GetUrlResponse>(url);
  }

  public deleteFile(path: string) {
    return this.http.delete(`${this.BASE_URL}?key=${path}`);
  }

  public deleteFolder(path: string) {
    return this.http.delete(`${this.BASE_URL}?key=${path}/`);
  }

  private getUploadHeaders(contentType: string): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": contentType,
    });
  }
}
